<template>
  <v-main>
    <keep-alive
      :include="[
        'LocationTable',
        'SubOrdersTableAdmin',
        'SubOrdersTable',
        'UsersTable',
        'OrdersTable',
        'ParentStocks',
        'Stocks',
        'OrdersTableAdmin',
        'ReturnSearchOrder',
        'ReturnTable',
        'TriggersTable',
        'TriggersHistoriesTable',
        'Reception',
        'InventoryTable',
        'InventoryReturnTable',
        'InStoreAppointmentServicesTable',
        'InStoreAppointmentsTable',
        'CarriersTable',
        'EbookingsSettingsTable',
        'deliveryTable',
        'OrdersInStoreTable',
        'OrdersSettingsTable',
        'ReturnSettingsTable',
        'GlobalSearchOrder',
        'ListsTable',
        'RefundTable',
        'DocumentsTable',
      ]"
      max="2"
    >
      <router-view />
    </keep-alive>
  </v-main>
</template>

<script>
  export default {
    name: 'MainView',
  }
</script>
